import { toast as sonnerToast } from 'sonner';

export function notify({ title, description, variant = 'default', duration, dismissible = true }) {
  const msg = title ?? description ?? '';
  const opts = { 
    description, 
    duration,
    dismissible,
    closeButton: true
  };
  
  switch (variant) {
    case 'destructive':
      return sonnerToast.error(msg, opts);
    case 'success':
      return sonnerToast.success(msg, opts);
    case 'info':
      return sonnerToast.info ? sonnerToast.info(msg, opts) : sonnerToast(msg, opts);
    default:
      return sonnerToast(msg, opts);
  }
}

export function dismiss(toastId) {
  sonnerToast.dismiss(toastId);
}

export function useToast() {
  return {
    toast: notify,
    dismiss
  };
}